// extracted by mini-css-extract-plugin
export var bottom = "Footer-module--bottom--+hOQW";
export var bottomContainer = "Footer-module--bottomContainer--n-Vs9";
export var footer = "Footer-module--footer--Pjmyf";
export var links = "Footer-module--links--Cbyaz";
export var linksSection = "Footer-module--linksSection--vKOW1";
export var main = "Footer-module--main--Shu-9";
export var miscellaneous = "Footer-module--miscellaneous--rM8n-";
export var rightCol = "Footer-module--rightCol--SZ52+";
export var social = "Footer-module--social--RC5sh";